
export class InformationPopupDataModel {
  
  /**
   * Relative path of a popup content
   * @type {string}
   */
  resourceKey;
  
  /** @type {string} */
  code;
  
  /** @type {boolean} */
  isHidden;
  
  /** @type {number} */
  version;
  
}
